// product-bar.js
(() => {
  let swupTransitioning = false;

  if (window.swup) {
    document.addEventListener('swup:visit:start', () => {
      swupTransitioning = true;
    });

    document.addEventListener('swup:page:view', () => {
      setTimeout(() => {
        swupTransitioning = false;
      }, 100);
    });
  }

  function updatePanelPosition() {
    const descriptionToggle = document.getElementById('descriptionToggle');
    const descriptionPanel = document.getElementById('productDescriptionPanel');
    const titleButton = document.querySelector('.product-bar__title');
    const productBar = document.querySelector('.product-bar');

    if (!descriptionToggle || !descriptionPanel || !titleButton || !productBar) return;

    const titleWidth = titleButton.offsetWidth;
    const toggleWidth = descriptionToggle.offsetWidth;
    if (titleWidth === 0 || toggleWidth === 0) return;

    const gap = 4;
    const totalWidth = titleWidth + toggleWidth + gap;
    descriptionPanel.style.width = `${totalWidth}px`;
    descriptionPanel.style.minWidth = `${totalWidth}px`;

    const rect = productBar.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const distanceFromBottom = viewportHeight - rect.bottom;
    const bottomOffset = distanceFromBottom + productBar.offsetHeight + 4;
    descriptionPanel.style.bottom = `${bottomOffset}px`;
  }

  // SEPARATE click handler ONLY for toggling - with stopPropagation
  document.addEventListener('click', (e) => {
    if (swupTransitioning) return;

    if (e.target.closest('#sizeGuideTrigger')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      const trigger = e.target.closest('#sizeGuideTrigger');
      const modal = document.querySelector(trigger.dataset.modal);
      if (modal && typeof modal.show === 'function') {
        modal.show(trigger);
      }
      return;
    }


    // Description toggle - STOP PROPAGATION immediately
    if (e.target.closest('#descriptionToggle')) {
      e.preventDefault();
      e.stopImmediatePropagation(); // Prevent ANY other handlers

      const descToggle = document.getElementById('descriptionToggle');
      const panel = document.getElementById('productDescriptionPanel');
      
      if (!descToggle || !panel) return;

      const isOpen = descToggle.getAttribute('aria-expanded') === 'true';
      const plusIcon = descToggle.querySelector('.icon-plus');
      const minusIcon = descToggle.querySelector('.icon-minus');

      ('Toggle clicked - setting to:', !isOpen);

      if (isOpen) {
        panel.classList.remove('active');
        descToggle.setAttribute('aria-expanded', 'false');
        if (plusIcon) plusIcon.style.display = 'inline-flex';
        if (minusIcon) minusIcon.style.display = 'none';
      } else {
        panel.classList.add('active');
        descToggle.setAttribute('aria-expanded', 'true');
        if (plusIcon) plusIcon.style.display = 'none';
        if (minusIcon) minusIcon.style.display = 'inline-flex';
      }

      ('After toggle:', {
        hasActiveClass: panel.classList.contains('active'),
        ariaExpanded: descToggle.getAttribute('aria-expanded')
      });
      return;
    }

    // Variant dropdown - STOP PROPAGATION immediately  
    if (e.target.closest('#customVariantButton')) {
      e.stopImmediatePropagation();

      const customButton = document.getElementById('customVariantButton');
      const customList = document.getElementById('customVariantList');
      
      if (!customButton || !customList) return;

      customButton.classList.toggle('open');
      customList.classList.toggle('open');
      return;
    }

    // Variant option selection
    if (e.target.closest('.custom-variant-option')) {
      const variantOption = e.target.closest('.custom-variant-option');
      if (variantOption.classList.contains('disabled')) return;

      const customButton = document.getElementById('customVariantButton');
      const customList = document.getElementById('customVariantList');
      const nativeSelect = document.getElementById('variantSelect');
      const priceElement = document.querySelector('.product-price');

      const value = variantOption.dataset.value;
      const price = variantOption.dataset.price;
      const text = variantOption.textContent.trim();

      if (customButton) {
        const textSpan = customButton.querySelector('.custom-variant-text');
        if (textSpan) textSpan.textContent = text;
      }

      if (nativeSelect) {
        nativeSelect.value = value;
        nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (priceElement && price) {
        priceElement.textContent = price.replace(/[,.]00/g, '');
      }

      if (customButton) customButton.classList.remove('open');
      if (customList) customList.classList.remove('open');
      return;
    }
  });

  // SEPARATE handler for clicking outside - lower priority
  document.addEventListener('click', (e) => {
    // Close description when clicking outside
    const descPanel = document.getElementById('productDescriptionPanel');
    const descToggle = document.getElementById('descriptionToggle');
    
    if (descPanel?.classList.contains('active')) {
      // Check if click is outside both panel and toggle
      if (!descPanel.contains(e.target) && !descToggle?.contains(e.target)) {
        ('Clicked outside - closing description');
        descPanel.classList.remove('active');
        if (descToggle) {
          descToggle.setAttribute('aria-expanded', 'false');
          const plusIcon = descToggle.querySelector('.icon-plus');
          const minusIcon = descToggle.querySelector('.icon-minus');
          if (plusIcon) plusIcon.style.display = 'inline-flex';
          if (minusIcon) minusIcon.style.display = 'none';
        }
      }
    }

    // Close variant dropdown when clicking outside
    const customBtn = document.getElementById('customVariantButton');
    const customLst = document.getElementById('customVariantList');
    
    if (customLst?.classList.contains('open')) {
      if (!customBtn?.contains(e.target) && !customLst.contains(e.target)) {
        if (customBtn) customBtn.classList.remove('open');
        customLst.classList.remove('open');
      }
    }
  }, true); // Use capture phase for outside clicks

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const descPanel = document.getElementById('productDescriptionPanel');
      const descToggle = document.getElementById('descriptionToggle');
      if (descPanel?.classList.contains('active')) {
        descPanel.classList.remove('active');
        if (descToggle) {
          descToggle.setAttribute('aria-expanded', 'false');
          const plusIcon = descToggle.querySelector('.icon-plus');
          const minusIcon = descToggle.querySelector('.icon-minus');
          if (plusIcon) plusIcon.style.display = 'inline-flex';
          if (minusIcon) minusIcon.style.display = 'none';
        }
      }

      const customBtn = document.getElementById('customVariantButton');
      const customList = document.getElementById('customVariantList');
      if (customList?.classList.contains('open')) {
        if (customBtn) customBtn.classList.remove('open');
        customList.classList.remove('open');
      }
    }
  });

  function initPositioning() {
    requestAnimationFrame(() => {
      updatePanelPosition();
      setTimeout(updatePanelPosition, 50);
      setTimeout(updatePanelPosition, 150);
      setTimeout(updatePanelPosition, 300);
    });
  }

  window.addEventListener('resize', () => {
    updatePanelPosition();
    setTimeout(updatePanelPosition, 50);
  });

  window.addEventListener('scroll', updatePanelPosition);

  if (document.fonts) {
    document.fonts.ready.then(() => setTimeout(updatePanelPosition, 100));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPositioning);
  } else {
    initPositioning();
  }

  document.addEventListener('swup:page:view', () => {
    setTimeout(initPositioning, 150);
  });
})();